import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CustomerSharedService } from '../../customer-shared.service';


@Component({
  selector: 'app-incidents',
  templateUrl: './incidents.component.html',
  styleUrls: ['./incidents.component.css']
})
export class IncidentsComponent implements OnInit {
  isLoading: boolean = false;
  isVisible: boolean = false;


  constructor(
    public customerSharedService: CustomerSharedService,
    public route: ActivatedRoute
  ) { }

  ngOnInit() {
  }
}
